// https://app.growthbook.io/features/prcng-1270_v1
export const MC_PRO_PROMO_FLAG_NAME = 'prcng-1270_v1'

export type MCProPromoBucket = 'control' | 'variant_1' | 'variant_2'
